import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    width: '100%',
    height: 70,
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
  },
  text: {
    fontWeight: 400,
    fontSize: 11,
    lineHeight: '1.8px',
    color: colors.neutral400,
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
});
